@if (hasHeader()) {
<rask-header size="2" underline>{{getHeaderTitle()}}
    <div class="right">
        <!-- todo: knappar för header-typ-meny -->
    </div>
</rask-header>
}

<arcgis-map #arcgisMap>
    <div id="widget-menu" slot="top-right">
        @if (view) {
        <div>
            @if ((layerCreationErrorMessage$|async).length > 0) {
            <rask-layer-error-message
                [layerNames]="layerCreationErrorMessage$ | async">
            </rask-layer-error-message>
            }

            <!-- Todo: slänga in alla knappar här?-->
            @for (btn of widgetMenuButtons; track btn) {
            <rask-map-menu-button [btn]="btn" [view]="view"
                [active]="isButtonActive(btn)"
                [visible]="isButtonVisible(btn)"
                (click)="widgetMenuButtonClick(btn)">
            </rask-map-menu-button>
            }
        </div>
        }
    </div>
    <div class="widget-container" #widgetContainer slot="top-right">
        <ng-content></ng-content>
    </div>
    @if(hasMultipleBasemaps()) {
    <arcgis-basemap-toggle #basemapToggle slot="bottom-right">
    </arcgis-basemap-toggle>
    }
    @if(mapsettings.zoomButtons) {
    <arcgis-zoom slot="bottom-right"></arcgis-zoom>
    }
    @if(mapsettings.scaleBar) {
    <arcgis-scale-bar slot="bottom-right" unit="metric">
    </arcgis-scale-bar>
    }
    @if(mapsettings.coords){
    <div #coordsWidget id="widget-coordinates" slot="bottom-right">
        <div>
            {{ coordsViewModel.getX() }} <span style="color: lightgray">|</span> {{ coordsViewModel.getY() }}
        </div>
    </div>
    }
    <div id="widget-navigate">
        <rask-navigate [data]="coordsViewModel"></rask-navigate>
    </div>
    <div #mapBottomLeftWidgets slot="bottom-left">
        <ng-content select="[bottom-left-widgets]"></ng-content>
    </div>
    <rask-map-popup></rask-map-popup>
</arcgis-map>